import { render, staticRenderFns } from "./PresetDropdownFooter.vue?vue&type=template&id=5e829e86"
import script from "./PresetDropdownFooter.vue?vue&type=script&lang=js"
export * from "./PresetDropdownFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports